import React, { useEffect, useState } from "react";
import Footer from "../components/Footer";
import Header from "../components/Header";
import ModalCadastro from "../components/modal-cadastro/ModalCadastro";
import BenefitsBlockVB from "../components/versao-b/BenefitsBlockVB";
import FaqBlockVB from "../components/versao-b/faqBlockVB";
import FirstBlockVB from "../components/versao-b/FirstBlockVB";
import FloatingWhatsAppVB from "../components/versao-b/FloatingWhatsAppVB";
import MenuMiddleVB from "../components/versao-b/MenuMiddleVB";
import RegisterBlockVB from "../components/versao-b/RegisterBlockVB";
import RzkBlockVB from "../components/versao-b/rzkBlockVB";
import useScroll from "../hooks/useScroll";

const MainV2 = () => {
  const [, setIsMobile] = useState(window.innerWidth < 768);
  const isScrolled = useScroll(50);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="overflow-hidden">
      <ModalCadastro open={false} setOpen={() => {}} />
      <Header />
      {/* Espaçamento para compensar o header fixo */}
      {isScrolled && <div className="h-[5rem]" />}
      <FirstBlockVB setShowModal={() => {}} />
      <MenuMiddleVB setShowModal={() => {}} />
      {/* <ComoFuncionaBlock /> */}
      <RegisterBlockVB />
      <RzkBlockVB />
      <BenefitsBlockVB setShowModal={() => {}} />
      <FaqBlockVB setShowModal={() => {}} />
      <FloatingWhatsAppVB />
      <Footer />
    </div>
  );
};

export default MainV2;
